import { Grid } from '@material-ui/core'
import React, { useState, useEffect, useContext } from 'react'
import { useCategory } from '../../../hooks/Features/useCategory'
import { useChannelType } from '../../../hooks/CompanyConfiguration/useChannelType'
import { useFeatures } from '../../../hooks/Features/useFeatures'
import { useQuery, useQueryClient } from 'react-query'
import CustomSelect from '../../CustomSelect'
import { sortByName } from '../../../shared/constants'
import useDebounce from '../../../hooks/useDebounce'
import { deleteDocumentById, getAllData } from '../../../lib/RestApi/customApiHandler'
import CustomAddForm from '../../../components/version-4/MasterForms/CustomAddForm'
import { CategoryContext } from '../../../context api/Category/CategoryContext'
import { SubCategoryContext } from '../../../context api/SubCategory/SubCategoryContext'
import CustomInput from '../../../components/CustomInput'

export default function SalesChannelTypeForm({ form, setForm }) {
  const { channelType, name, contact, email, address, businessCardImg, shopImg, remarks, category, companyName } = form
  const [bImg, setBImg] = useState('')
  const [sImg, setSImg] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  // const { getAllCategories } = useCategory()
  const { getAllChannelType } = useChannelType()
  // const { getAllsubCategoryByCategory } = useFeatures()
  // const { categories } = useContext(CategoryContext)
  // const { subcategories } = useContext(SubCategoryContext)
  const debouncedValue = useDebounce(searchQuery, 500)
  let { data: channelTypeMaster, isLoading } = useQuery(['channel-type-master'], () => getAllData('/channel/types', { searchQuery: debouncedValue }))
  let tmpArr = []
  if (!isLoading && channelTypeMaster?.data?.length > 0) {
    channelTypeMaster.data.map((item) => {
      return tmpArr.push({ name: item.name, _id: item._id })
    })
  }

  // console.log(channelTypeMaster?.data)

  // useEffect(() => {
  //   if (category) {
  //     getAllsubCategoryByCategory({ categoryId: category })
  //   }
  // }, [category])

  useEffect(() => {
    console.log('bImg', bImg)
    setForm({ ...form, businessCardImg: bImg })
  }, [bImg])

  useEffect(() => {
    console.log('sImg', sImg)
    setForm({ ...form, shopImg: sImg })
  }, [sImg])

  useEffect(() => {
    // getAllCategories()
    getAllChannelType()
  }, [])

  const inputField = [
    // { label: 'Channel Name', value: channelName, name: 'channelName', options: channelTypeMaster },
    {
      label: 'Select Channel Type',
      value: channelType,
      name: 'channelType',
      fieldName: 'name',
      fieldValue: '_id',
      options: channelTypeMaster?.data,
    },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Company Name', value: companyName, name: 'companyName' },
    { label: 'Email', value: email, name: 'email' },
    { label: 'Contact', value: contact, name: 'contact' },
    // { label: 'Business Card Image', value: businessCardImg, name: 'businessCardImg' },
    // { label: 'Shop Image', value: shopImg, name: 'shopImg' },
    { label: 'Address', value: address, name: 'address' },
    { label: 'Remarks', value: remarks, name: 'remarks' },
    // {
    //   label: 'Select Category',
    //   type: 'MULTI',
    //   value: category,
    //   name: 'category',
    //   fieldName: 'categoryName',
    //   fieldValue: '_id',
    //   options: sortByName(categories, 'categoryName'),
    // },
    // console.log('yoyo', `as ${email} k9`, 'ko', category),
    // {
    //   label: 'Select Sub Category',
    //   value: subCategory,
    //   name: 'subCategory',
    //   fieldName: 'name',
    //   fieldValue: '_id',
    //   options: sortByName(subcategories),
    // },
    // {
    //   label: "Business Card Image Logo",
    //   // 'handleChange'={setBImg}s
    //   type:'file',
    //   single: true,
    //   name: 'shopImg',
    // }
  ]

  return (
    <>
      <CustomAddForm state={form} setState={setForm} data={inputField}
      address={address}
      setAddress={(val) => {
        setForm({ ...form, address: val })
      }}
      setCoordinages={(ll)=>{
        console.log(ll)
      }} />
      <CustomInput
        label={'Business Card Image Logo'}
        handleChange={setBImg}
        type="file"
        single={true}
        name="bImg"
        // name= 'shopImg'
      />

      {(businessCardImg !== '' || bImg !== '') && (
        <div>
          <img style={{ margin: '10px', maxWidth: '600px', height: '200px', display: 'flex', objectFit: 'fill', borderRadius: '10px' }} src={bImg || businessCardImg} alt="business card" />
        </div>
      )}
      <CustomInput
        label={'Shop Image'}
        handleChange={setSImg}
        type="file"
        single={true}
        name="sImg"
        // single= {true}
      />

      {(shopImg !== '' || sImg !== '') && (
        <div>
          <img style={{ margin: '10px', width: '400px', height: '200px', display: 'flex', objectFit: 'cover', borderRadius: '10px' }} src={sImg || shopImg} alt="shop" />
        </div>
      )}
    </>
  )
}
